var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"coverauth"},[_c('div',{staticClass:"get_phone",on:{"click":_vm.getphone}},[_vm._v("授权手机号")]),_c('img',{staticClass:"dele_logo",attrs:{"src":require("../../cmmon/image/del@2x.png"),"alt":""},on:{"click":_vm.close}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }